import { z } from "zod";

export type EntityMemberSummaryJSON = z.infer<typeof EntityMemberSummarySchema.EntityMemberSummaryJSONZ>;

/**
 * One row of `GET legal-entities/{legalEntityId}/members`: a member with what a roster shows of
 * them, so that no second request is needed to draw the row (#5442).
 */
export default class EntityMemberSummarySchema {
  public static readonly EntityMemberSummaryJSONZ = z.object({
    userId: z.uuid(),
    legalEntityId: z.uuid(),
    /** Null when the member has no marketplace individual. They are still a member. */
    individualId: z.uuid().nullish(),
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
    avatarId: z.uuid().nullish(),
    hasCredentials: z.boolean(),
    hasSigningAuthority: z.boolean(),
    isPrincipal: z.boolean(),
    /** The user's creation date. The membership row has no date of its own. */
    dateJoined: z.string(),
  });
}
